export default {
  FormImport: require('./FormImport').default,
  FormImportFeedback: require('./FormImportFeedback').default,
}
